import ListUsersPage from './ListUsersPage';
import LoadingSpinner from '../../../components/LoadingSpinner';
import { skipToken } from '@reduxjs/toolkit/dist/query';
import { useGetMerchantByIdQuery } from '../../merchants/merchant.api-slice';
import { useParams } from 'react-router-dom';

interface IProps {
  pendingOnly?: boolean;
}

const ListUsersForMerchantPage: React.FC<IProps> = ({ pendingOnly }) => {
  const { id } = useParams();
  const { data, isLoading } = useGetMerchantByIdQuery(id ?? skipToken);

  if (isLoading || id == null) {
    return <LoadingSpinner />;
  }

  return <ListUsersPage scope={'merchant'} merchant={data} />;
};

export default ListUsersForMerchantPage;
